import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: !!localStorage.getItem('isLogin'),
    userRole: localStorage.getItem('userRole') || ''
  },
  mutations: {
    login(state) {
      state.isLogin = true
      localStorage.setItem('isLogin', '1')
    },
    setRole(state, role) {
      state.userRole = role
      if (role) {
        localStorage.setItem('userRole', role)
      } else {
        localStorage.removeItem('userRole')
      }
    },
    logout(state) {
      state.isLogin = false
      localStorage.removeItem('isLogin')
      state.userRole = ''
      localStorage.removeItem('userRole')
    }
  }
}) 